<div class="sidebar">
    <div class="sidebar_content row align-items-center">

        <!-- Logo SDLV -->
        <div class="col-4 col-sm-3 col-lg-2 iconeSDLV col-xl-12 iconeSDLV d-flex w-100 justify-content-center">
            <img alt="icone SportDansLaVille" class="icon_sdlv" src="assets/images/logo_sport_ville_sidebar.svg">
        </div>
        <!-- Titre page -->
        <div class="col-6 col-sm-3 col-lg-5 sideBarTitle col-xl-12 d-flex w-100 justify-content-center">
            <p class="sidebar_title">Formulaire d'inscription</p>
        </div>
        <!-- Stepper material -->
        <div class="offset-1 col-10 col-sm-5 col-lg-5 offset-lg-0 stepper_inscription offset-xl-0 col-xl-12 d-flex w-100 justify-content-center">
            <mat-horizontal-stepper #stepper [linear]="true" id="stepperInscription">
                <ng-template [ngForOf]="[].constructor(nbStep)" ngFor>
                    <mat-step>
                    </mat-step>
                </ng-template>
            </mat-horizontal-stepper>
        </div>
        <!-- Text Explications -->
        <div class="offset-md-1 col-md-7 col-lg-7 colTextExplication offset-xl-0 col-xl-12">
            <span class="complete-info">Complétez les informations pour valider l’inscription de votre enfant</span>
        </div>

    </div>
    <div class="sidebar-bottom">
        <button mat-button (click)="goToLogin()">Connexion</button>
        <div class="version">{{ version }}</div>
    </div>
</div>
